import { Component, Input } from '@angular/core';
import { MyCasesData } from '../../../service/cases.service';
import { MatDialog } from '@angular/material/dialog';
import { LeadDetailsModalComponent } from '../../lead-details-modal/lead-details-modal.component';

@Component({
  selector: 'app-kanban-card',
  templateUrl: './kanban-card.component.html',
  styleUrls: ['./kanban-card.component.scss'],
})
export class KanbanCardComponent {
  @Input()
  lead!: MyCasesData;

  constructor(private readonly dialog: MatDialog) {}

  showTag() {
    return this.lead.lastObservationStatus === this.lead.status && !!this.lead.lastObservation;
  }

  openDetails() {
    const ref = this.dialog.open(LeadDetailsModalComponent, {
      data: { leadId: this.lead.id },
      maxWidth: '720px',
      width: 'calc(100vw - 32px)',
      position: { top: '10vh' },
      panelClass: 'lead-details-dialog',
    });

    ref.afterClosed().subscribe((lastObservation) => {
      if (lastObservation) {
        this.lead.lastObservation = lastObservation;
      }
    });
  }
}
